<script lang="ts">
	import Avatar from "#lib/components/Avatar.svelte";
	import type { ComponentProps } from "#lib/components/page/ComponentProps.js";
	import { structValue } from "#lib/struct.js";

	let { id, style, page }: ComponentProps = $props();

	const config = $derived(structValue($page.config, id));
</script>

<Avatar {...config} rounded {style} />
